import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../core/shared/service/crud/mvs-crud-mode.enum';

/**
 * [CW-PERSON-REFACTOR] Generic CRUD service of {@code cw.CwCasePersonRoleField}
 * ({@code /mvsa/cw/casePersonRoleFields}) — the generic value bag of a CASE-level person role.
 *
 * <h3>The second family on a shared field pool</h3>
 * Its field POOL is {@code cw.CwCaseTypePersonField}, the same pool the product-level bag
 * {@code cw.CwCaseProductPersonField} uses. Two generic-template families on one type class are
 * legal: the framework registry keys on the INSTANCE class and states explicitly that the type class
 * is not a unique discriminator. Where an instance is genuinely ambiguous the framework answers with
 * a modelled HTTP 400, never with a silent overwrite — so a config surface that renders this pool
 * type-scoped has to send the instance alias along.
 *
 * <h3>Not the write path for a value</h3>
 * A captured value is written through the HOST row under the {@code gen_<typeFieldId>} key
 * ({@code CwCasePersonRoleDto.setGenericValue}), which the framework maps onto the
 * {@code cc.FieldValue} substrate. This service exists so the alias resolves for reads and for the
 * configuration surfaces; creating a row of this entity by hand bypasses the substrate mapping.
 */
@Injectable({
    providedIn: 'root',
})
export class CwCasePersonRoleFieldService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cw/casePersonRoleFields');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

}
